import React, { Component } from "react"
import { Link } from "react-router-dom"

import {
  configMaterialComponents,
  removeMaterialComponents,
} from "../../../utils/MaterialFunctions"

class Home extends Component {
  componentWillMount() {
    removeMaterialComponents()
  }

  componentDidMount() {
    configMaterialComponents()
  }

  render() {
    return (
      <React.Fragment>
        <header className="normal-site">
          <nav className="blue darken-1">
            <div className="container">
              <div className="nav-wrapper">
                <a href="https://sproducts.angel2h.com" className="brand-logo">
                  SProducts
                </a>
                <a
                  href="#!"
                  className="sidenav-trigger"
                  data-target="nav_sidenav"
                >
                  <i className="material-icons">menu</i>
                </a>
                <ul className="right hide-on-small-only">
                  <li>
                    <Link to="/login">Login</Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          <ul className="sidenav" id="nav_sidenav">
            <li>
              <Link to="/login">Login</Link>
            </li>
          </ul>
        </header>
        <div className="row normal-site">
          <div className="showcase" />
        </div>

        <main className="grey lighten-5 normal-site">
          <div className="container">
            <div className="row">
              <div className="col s12">
                <h4>Nuestra propuesta</h4>
                <div className="card">
                  <div className="card-content">
                    <p>
                      Un sistema flexible y escalable para gestion de inventarios, ventas, cotizaciones, clientes, pedidos, proveedores y todo
                      lo que puedas agregar.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <footer className="blue darken-4 white-text normal-site">
          <div className="container">
            <div className="row mb-0">
              <p className="col s12">
                <span className="d-flex space-between">
                  <span>SProducts &copy; {new Date().getFullYear()}</span>
                  <a href="mailto:contacto@angel2h.com">
                    contacto@angel2h.com
                  </a>
                </span>
              </p>
            </div>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}

export default Home
